module.exports = __webpack_public_path__ + "img/article_bg.f76e7fe0.jpg";